export default {"src":"/_next/static/media/Labors.75214eff.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};